<template>
  <app-input-text
    ref="input"
    v-model="model"
    :class="optionClass"
    :disabled="computedDisabled"
    :options="transparentOptions"
    @app-event="onAppEvent">
  </app-input-text>
</template>

<script>
/* eslint-disable semi */
import { Component, Watch } from 'vue-property-decorator';
import AppInputComponent from '../input/AppInputComponent';
import AppInputText from '../input/AppInputText';

@Component({
  components: { AppInputText }
})
export default class AppZen extends AppInputComponent {
  data () {
    return {
      innerValue: null
    }
  }

  @Watch('value', {immediate: true})
  onValueChange (value) {
    this.innerValue = value;
  }

  /**
   * v-model対応
   */
  get model () {
    return this.innerValue;
  }

  /**
   * v-model対応
   */
  set model (value) {
    this.innerValue = value;
  }

  get transparentOptions () {
    return (this.options) ? this.options : {};
  }

  /**
   * 値変更イベント
   */
  onAppEvent (...args) {
    if (args[0] === 'change') {
      // 入力コンポーネントを元の値に一旦戻す
      // 上位コンポーネントでvalueの値が変更された時点で変更後の値に更新される
      this.innerValue = this.value;

      // 内部値としてコード値補正
      let val = args[2];
      val = this.appUtils.toDoubleWidth(val);
      const changedValue = val;

      // 変更イベントを通知
      const from = this.value;
      const to = changedValue;

      this.$emit('input', to);
      this.$emit('app-event', 'change', this, from, to);
      return;
    }
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/ex/AppZen.vue